export const NAVIGATION = {
    ANALYTICS: 'analytics',
    CHANGE_PASSWORD: 'change_password',
    CLIENTS: 'clients',
    CONSOLE: 'console',
    LEGACY_ANALYTICS: 'legacy_analytics',
    LOG_OUT: 'log_out',
    MODERATION: 'moderation',
    MY_PROFILE: 'my_profile',
    SITE_SETTINGS: 'site_settings',
    SWITCH_SITES: 'switch_sites',
    USERS: 'users',
    PORTAL: 'portal',
};
